<div class="container">
    <div class="row mb-3" *ngIf="operator">
        <div class="col-12">
            <h2 class="my-4" i18n>Datos del operador</h2>
            <div class="card">
                <div class="row">
                    <div class="col-sm-6 col-md-2 mb-3">
                        <label for="identifier" class="form-label"><span i18n>Identificación</span>:</label>
                        <input type="text" class="form-control" id="identifier" [(ngModel)]="operator.identifier" required>
                    </div>
                    <div class="col-sm-6 col-md-4 mb-3">
                        <label for="name" class="form-label"><span i18n>Nombre</span>:</label>
                        <input type="text" class="form-control" id="name" [(ngModel)]="operator.name" required>
                    </div>
                    <div class="col-sm-6 col-md-4 mb-3">
                        <label for="email" class="form-label"><span i18n>Email</span>:</label>
                        <input type="text" class="form-control" id="email" [(ngModel)]="operator.email" required>
                    </div>
                    <div class="col-sm-6 col-md-2 mb-3">
                        <label for="level" class="form-label"><span i18n>Nivel</span>:</label>
                        <select id="level" class="form-select" [(ngModel)]="operator.exceptions_profile" required>
                            <option value="level1" i18n>Nivel 1</option>
                            <option value="level2" i18n>Nivel 2</option>
                        </select>
                    </div>
                    <div class="col-12 mb-3">
                        <label for="municipalities" class="form-label"><span i18n>Municipio</span>:</label>
                        <select id="municipalities" class="form-select" [(ngModel)]="operator.municipalities" multiple required>
                            <option value="">-----</option>
                            <option *ngFor="let municipality of municipalities" [value]="municipality.municipality.municipalityName">{{municipality.municipality.municipalityName}}</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-12 mb-4 text-center">
            <button type="button" class="btn btn-primary btn-rounded mr-3" (click)="save()" i18n>Guardar</button>
            <button type="button" class="btn btn-secondary btn-rounded ml-3" (click)="goBack()" i18n>Volver</button>
        </div>
    </div>
</div>